import { Link } from "react-router-dom";
import { PageBanner } from "@/shared/components/PageBanner";

export function ProductionHomePage() {
  return (
    <div style={{ padding: "0.5rem 0", maxWidth: "100%", margin: "0" }}>
      <PageBanner
        title="پیش‌خوان سفارشات و خطوط تولید"
        subtitle="مدیریت سفارشات کارخانه، خطوط و دستگاه‌ها، مسیریابی و عملیات جاری ساخت"
        icon="⚡"
        helpLink="/help/production/home"
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "1.5rem",
        }}
      >
        <Link
          to="/production/lines"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            🏭
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            خطوط و دستگاه‌ها
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مدیریت گرافیکی خطوط تولید، ایستگاه‌های کاری و ماشین‌آلات
          </p>
        </Link>

        <Link
          to="/production/orders"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            📋
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            لیست سفارشات تولید
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            مشاهده و مدیریت وضعیت سفارشات و کارهای تولیدی جاری
          </p>
        </Link>

        <Link
          to="/production/orders/create"
          className="brand-card-extand block"
          style={{ padding: "1.5rem", textDecoration: "none" }}
        >
          <div style={{ fontSize: "2.2rem", marginBottom: "0.75rem" }}>
            ⚡
          </div>
          <h3 style={{ fontSize: "1.1rem", fontWeight: "800", color: "#007270", marginBottom: "0.5rem" }}>
            سفارش تولید جدید
          </h3>
          <p style={{ color: "var(--color-text-main)", fontSize: "0.85rem", margin: 0 }}>
            ایجاد سفارش تولید جدید بر اساس BOM و Routing
          </p>
        </Link>
      </div>
    </div>
  );
}
